import Immutable from 'immutable';
import {
  FLAG_BAGGAGE_CONFIGURATION_ACTIVITY,
  GET_BAGGAGE_CONFIGURATION,
  CLEAR_BAGGAGE_CONFIGURATION,
} from '../../../actions/types/baggage';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_BAGGAGE_CONFIGURATION_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BAGGAGE_CONFIGURATION:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_BAGGAGE_CONFIGURATION:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
